import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addressTypeOption, odsCallOutBoxs } from "../../entities/Constants";
import { Checkbox } from "primereact/checkbox";
import { Editor } from "primereact/editor";
import { InputTextarea } from "primereact/inputtextarea";


interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;

}

export class DialongforAddressComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={"Set up API for section " + this.props.ele.ENUTitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.addressHtml()}
                </Dialog>
            </>
        );
        return html;
    }

    addressHtml = () => {
        let htmlString = [];
        htmlString.push(
            <>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"API_for_postal_code_search"}>API for postal code search</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"API_for_postal_code_search"} value={this.props.ele.PCLookupUrl} className="ontario-input"
                            onChange={(e) => { this.props.ele.PCLookupUrl = e.target.value; this.props.callback() }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"API_for_address_search"}>API for address search </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"API_for_address_search"} value={this.props.ele.AddressLookupUrl} className="ontario-input"
                            onChange={(e) => { this.props.ele.AddressLookupUrl = e.target.value; this.props.callback() }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Regular Expression</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.ele.RegularExpression} onChange={(e) => {
                        this.props.ele.RegularExpression = e.target.value;
                        this.props.callback();
                    }}></InputText></div>
                </div>


                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Question Hint</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor style={{ height: 'auto' }}
                            value={this.props.isEng ? this.props.ele.Hint : this.props.ele.HintFR} onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.Hint = e.htmlValue;
                                else
                                    this.props.ele.HintFR = e.htmlValue;

                                this.props.callback();
                            }}></Editor></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Tool Tip</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} onChange={(e) => {
                        if (this.props.isEng)
                            this.props.ele.TooltipENU = e.target.value;
                        else
                            this.props.ele.TooltipFRA = e.target.value;

                        this.props.callback();
                    }}></InputText></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Empty Error Message</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng ? this.props.ele.EmptyErrorMessage: this.props.ele.EmptyErrorMessageFRA} onChange={(e) => {
                        if (this.props.isEng)
                            this.props.ele.EmptyErrorMessage = e.target.value;
                        else
                            this.props.ele.EmptyErrorMessageFRA = e.target.value;
                        this.props.callback();
                    }}></InputText></div>
                </div>

                <div style={{ display: this.props.ele.Optional == 'N' ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Custom Error Message</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng ? this.props.ele.ErrorMessage: this.props.ele.ErrorMessageFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.ErrorMessage = e.target.value;
                            else
                                this.props.ele.ErrorMessageFRA = e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Hint Expansion Title</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng ? this.props.ele.hintExpansionTitle: this.props.ele.hintExpansionTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng) {
                                this.props.ele.hintExpansionTitle = e.target.value;
                            }
                            else {
                                this.props.ele.hintExpansionTitleFRA = e.target.value;
                            }
                            this.props.callback();
                        }}></InputText></div>
                </div>

                {/* Alert box options */}
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e) => {
                            this.props.ele.callOutBoxType = e.value;
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Title</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxTitle : this.props.ele.callOutBoxTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.callOutBoxTitle = e.target.value;
                            else
                                this.props.ele.callOutBoxTitleFRA = e.target.value;

                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Body Message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.callOutBoxBody = e.htmlValue;
                                else
                                    this.props.ele.callOutBoxBodyFRA = e.htmlValue;
                                this.props.callback();
                        }}></Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input"
                            value={this.props.ele.Script} onChange={(e) => {
                                this.props.ele.Script = e.target.value;
                                this.props.callback();
                            }}></InputTextarea></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Address type: </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear options={addressTypeOption} optionLabel='label' optionValue='val' value={this.props.ele.addressType}
                            onChange={(e) => {
                                this.props.ele.addressType = e.target.value;
                                this.props.callback();
                            }}
                        ></Dropdown>
                    </div>
                </div>

                {this.props.ele.addressType === 'Mailing' && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"maskinsummary_" + this.props.ele.Sequence}>Show mailing details when same as residential</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.ele.showMailingDetails} id={"show-mainling-detail" + this.props.ele.Sequence}
                                checked={this.props.ele.showMailingDetails}
                                onChange={(e) => { this.props.ele.showMailingDetails = e.checked; this.props.callback() }} 
                            />
                        </div>
                    </div>
                )}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"maskinsummary_" + this.props.ele.Sequence}>Mask in Summary</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.MaskInSummary} id={"maskinsummary_" + this.props.ele.Sequence}
                            onChange={(e) => { this.props.ele.MaskInSummary = e.checked; this.props.callback() }} checked={this.props.ele.MaskInSummary} />
                    </div>
                </div>
            </>



        )

        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
